import { render, staticRenderFns } from "./SelectExtensionModal.vue?vue&type=template&id=04878c1e&"
import script from "./SelectExtensionModal.vue?vue&type=script&lang=js&"
export * from "./SelectExtensionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports